<template>
   <div class="container px-0 bg-danger">
   <div class="offcanvas offcanvas-end rounded-2 shadow bg-light" 
         data-bs-scroll="true" 
         data-bs-backdrop="false" 
         tabindex="-1" 
         id="offcanvasFrontPage" 
         aria-labelledby="offcanvasFrontPageLabel"
         @blur="focusOff()"
      >
      <!--
         @blur="focusOff()"
      -->
      <div class="offcanvas-header">
         <h6 id="offcanvasFrontPageLabel">Portada ({{cnttId}})</h6>
         <button type="button" class="btn-close btn-sm text-reset" data-bs-dismiss="offcanvas" aria-label="Close" ref="btn_out_offcanvas"></button>
      </div>
      <hr class="m-0"/>
      <div class="offcanvas-body gap-0">
         <div class="row px-1 gap-2">
            <div v-for="(color, index) in colors" 
                  :key="index" 
                  class="fp-bg-color rounded" 
                  :style="{'background-color': color.background}" 
                  @click="setColorId(color.id)"
                  ></div>
         </div>
         <div v-if="content.frontPageColor" class="row px-1 pt-2">
            <div class="fp-onOff btn-info rounded" @click="setColorId(0)">
               Quitar portada
            </div>
         </div>
      </div>
         <!--
         -->
   </div>
   </div>
</template>

<script>
//import { ref, nextTick, watchEffect } from 'vue';
import { ref, onMounted } from 'vue'
import { useStore } from 'vuex'

import WspService from "../workSpace.service";

export default {
   setup() {
      const store = useStore()
      const cnttId = ref(store.state.wspace.contentId)
      const btn_out_offcanvas = ref(null)
      const boardId = ref(null)
      const cellId = ref(0)
      const colors = ref({})
      const content = ref({})

      onMounted(() => {
         let myOffCanvas = document.getElementById('offcanvasFrontPage')
         myOffCanvas.addEventListener('shown.bs.offcanvas', function (event) {
         console.log(store.state.wspace.contentId)
         cnttId.value = store.state.wspace.contentId
         let button = event.relatedTarget
         cellId.value = button.getAttribute('data-cell-id')
         boardId.value = WspService.getBoardId(store)
         getContent(cnttId.value)
         //getColors(1)
         myOffCanvas.focus()
         console.log(" show label's OC")
         })
         console.log("label's OC")
      })

      function getColors(type) {
         WspService.getColors(type)
         .then(response => {
            //console.log(response.data)
            colors.value = response.data
            //console.log("colors ok: "+colors.value)
         })
         .catch(error => {
            console.log(error);
         });
      }
      
      function getContent(contentId) {
         WspService.getContent(contentId)
         .then(response => {
            console.log(response.data)
            content.value = response.data
            getColors(0)
            console.log("content ok: "+content.value.title)
         })
         .catch(error => {
            console.log(error);
         });
      }
      
      function setColorId (colorId) {
         //console.log("si-0")
         /*
         */
         let cnttData = {}
            cnttData.fpColorId = colorId
         WspService.upContent(
            cnttId.value,    // contentId,
            cellId.value,    // cellId,
            boardId.value,   // boardId
            'FPC',   // code
            cnttData    // cnttData
         )
         .then(response => {
            getContent(response.data)
            store.dispatch("wspace/setContentId", -2)
            //
            //setTimeout(getContent(response.data),125)
            //
         })
         .catch(error => {
            console.log(error);
         });
         /*
         nextTick(() => {
            store.dispatch("wspace/setContentId", -2)
         })
         */
      }
      function focusOff() {
         //
         let timer = 1;
         let interval = setInterval(() => {
         if (timer === 0) {
            clearInterval(interval)                
         } else {
            timer--
            console.log(timer)
            btn_out_offcanvas.value.click()
            console.log(timer)
         }             
         }, 125)
         //
         //         this.$refs.btnEdit.click(); btn-out-offcanvas
         //console.log("sali del offCanvas")
      }

      return {
         btn_out_offcanvas,
         focusOff,
         cellId,
         cnttId,
         colors,
         content,
         setColorId,
      }
   }
}
</script>

<style scoped>
.offcanvas-end {
  top: 150px;
  right: 100px;
  width: 350px;
  height: fit-content;
}
.btn-info {
   background-color: #e5e7e9;
   border-color: #e5e7e9 ;
}
.btn-info:hover {
   background-color:  #cacfd2 ;
}
.btn-sm {
   width: max-content;
}
.fp-bg-color {
  width: 60px;
  height: 40px;
}
.fp-onOff {
  width: 333px;
  height: 30px;
  text-align: center;
}
</style>